// Keep in sync with ALLOWED_REDIRECT_PATHS in apps/jersey-api/src/constants.ts
export const ALLOWED_REDIRECT_PATHS = ['/Dashboard', '/dashboard']
